import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { FaBars, FaSearch, FaShoppingBasket, FaTimes } from "react-icons/fa";
import Button from "../ui/Button";
import { useQuote } from "../../context/QuoteContext";

const links = [
 { to: "/", label: "Home" },
 { to: "/categories", label: "Categories" },
 { to: "/products", label: "Products" },
 { to: "/about", label: "About" },
 { to: "/contact", label: "Contact" },
];

export default function Navbar() {
 const [open, setOpen] = useState(false);
 const [scrolled, setScrolled] = useState(false);
 const { count } = useQuote();

 useEffect(() => {
  const onScroll = () => setScrolled(window.scrollY > 8);
  onScroll();
  window.addEventListener("scroll", onScroll);
  return () => window.removeEventListener("scroll", onScroll);
 }, []);

 const navClass = ({ isActive }) =>
  `text-sm font-bold transition hover:text-primary ${isActive ? "text-primary" : "text-dark"}`;

 return (
  <header
   className={`sticky top-0 z-50 border-b border-line bg-white/95 backdrop-blur transition ${scrolled ? "shadow-soft" : ""}`}
  >
   <nav
    className="container-pad flex min-h-20 items-center justify-between gap-4"
    aria-label="Main navigation"
   >
    <NavLink
     to="/"
     className="flex items-center gap-3"
     onClick={() => setOpen(false)}
    >
     <img
      src={"/logo.jpeg"}
      alt="Mozo EV Logo"
      className="h-12 w-12 rounded-xl object-contain"
     />

     <span>
      <span className="block text-xl font-bold leading-none text-dark">
       Mozo EV
      </span>
      <span className="text-xs font-bold uppercase tracking-wider text-slate-500">
       Battery Catalogue
      </span>
     </span>
    </NavLink>

    <div className="hidden items-center gap-8 lg:flex">
     {links.map((link) => (
      <NavLink key={link.to} to={link.to} className={navClass}>
       {link.label}
      </NavLink>
     ))}
    </div>

    <div className="hidden items-center gap-3 lg:flex">
     <NavLink
      to="/products"
      className="grid h-11 w-11 place-items-center rounded-xl border border-line text-dark transition hover:border-primary hover:text-primary"
      aria-label="Search products"
     >
      <FaSearch />
     </NavLink>
     <NavLink
      to="/quote"
      className="relative grid h-11 w-11 place-items-center rounded-xl border border-line text-dark transition hover:border-primary hover:text-primary"
      aria-label="Quote cart"
     >
      <FaShoppingBasket />
      {count > 0 && (
       <span className="absolute -right-2 -top-2 grid h-6 min-w-6 place-items-center rounded-full bg-primary px-1 text-xs font-bold text-white">
        {count}
       </span>
      )}
     </NavLink>
     <Button to="/request-quote">Request Quote</Button>
    </div>

    <div className="flex items-center gap-2 lg:hidden">
     <NavLink
      to="/quote"
      className="relative grid h-11 w-11 place-items-center rounded-xl border border-line text-dark transition hover:border-primary hover:text-primary"
      aria-label={`Quote cart${count ? `, ${count} items` : ""}`}
      onClick={() => setOpen(false)}
     >
      <FaShoppingBasket />
      {count > 0 && (
       <span className="absolute -right-2 -top-2 grid h-6 min-w-6 place-items-center rounded-full bg-primary px-1 text-xs font-bold text-white">
        {count}
       </span>
      )}
     </NavLink>
     <button
      className="grid h-11 w-11 place-items-center rounded-xl border border-line text-dark"
      onClick={() => setOpen((value) => !value)}
      aria-label="Toggle menu"
      aria-expanded={open}
     >
      {open ? <FaTimes /> : <FaBars />}
     </button>
    </div>
   </nav>

   {open && (
    <div className="border-t border-line bg-white lg:hidden">
     <div className="container-pad grid gap-2 py-5">
      {links.map((link) => (
       <NavLink
        key={link.to}
        to={link.to}
        className="rounded-xl px-3 py-3 text-sm font-bold text-dark hover:bg-emerald-50 hover:text-primary"
        onClick={() => setOpen(false)}
       >
        {link.label}
       </NavLink>
      ))}
      <div className="mt-3 grid gap-3 sm:grid-cols-2">
       <Button to="/request-quote" onClick={() => setOpen(false)}>
        Request Quote
       </Button>
       <Button to="/products" variant="secondary" onClick={() => setOpen(false)}>
        <FaSearch /> Browse Products
       </Button>
      </div>
     </div>
    </div>
   )}
  </header>
 );
}
